import React, { FunctionComponent, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Loader from 'components/loader/loader';
import cancelXIcon from 'assets/images/profile-icons/cancel-x.png';
import sendInviteTicker from 'assets/svg/send-invite-ticker.svg';
import { useMenuBottomActionsRef } from 'views/profile/landing/MenuBottomActionsContext';
import Styles from 'components/settingsActionButtons/SettingsActionButtons.module.scss';

export interface SettingsActionButtonsProps {
  onCancel: () => void;
  onSave: () => void;
  saving?: boolean;
  cancelLabel?: string;
  saveLabel?: string;
}

/**
 * Shared Cancel / Save Changes CTAs for settings pages under MenuLanding.
 * Portals into the shell bottom bar so styles match Edit Profile everywhere.
 */
const SettingsActionButtons: FunctionComponent<SettingsActionButtonsProps> = ({
  onCancel,
  onSave,
  saving = false,
  cancelLabel = 'Cancel',
  saveLabel = 'Save Changes',
}) => {
  const bottomActionsRef = useMenuBottomActionsRef();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const buttons = (
    <div className={Styles.actionButtonsGroup}>
      <button className={Styles.cancelBtn} onClick={onCancel} type="button">
        {cancelLabel}
        <img src={cancelXIcon} alt="" className={Styles.actionBtnIcon} />
      </button>
      <button
        className={Styles.saveBtn}
        onClick={onSave}
        type="button"
        disabled={saving}
      >
        {saving && <Loader />}
        {saveLabel}
        <img src={sendInviteTicker} alt="" className={Styles.saveBtnIcon} />
      </button>
    </div>
  );

  if (!mounted || !bottomActionsRef.current) return null;
  return createPortal(buttons, bottomActionsRef.current);
};

export default SettingsActionButtons;
